import { stateLabel } from "../state-label";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";
import { describeToolSearch } from "./describe-tool-search";

// Harness-native tools matched on their lowercased name (Claude Code, Cursor).
export const nativeToolActivityDescribers: readonly [
  string,
  (record: Record<string, unknown>, state: ToolActivityState) => ToolActivity,
][] = [
  ["toolsearch", describeToolSearch],
  [
    "readlints",
    (_, state) =>
      stateLabel(state, {
        done: "Read the lint diagnostics",
        running: "Reading the lint diagnostics",
        failed: "Could not read the lint diagnostics",
      }),
  ],
];
